import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker } from "@/lib/push";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker for PWA + push
if (process.env.NODE_ENV === "production" || "serviceWorker" in navigator) {
  window.addEventListener("load", () => { registerServiceWorker(); });
}
